import api from "@/services/api";
import { EditorProfile, EditorProfileSave } from "./types";

export async function getEditorProfiles(): Promise<Array<EditorProfile>> {
    return new Promise((resolve, reject) => {
        api.get("/editorProfile").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getEditorProfile(id: string): Promise<EditorProfile> {
    return new Promise((resolve, reject) => {
        api.get(`/editorProfile/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserEditorProfile(id: string): Promise<EditorProfile> {
    return new Promise((resolve, reject) => {
        api.get(`/editorProfile/user/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkEditorProfileUsage(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        api.get(`/editorProfile/usage/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteEditorProfile(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        api.delete(`/editorProfile/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateEditorProfile(editorProfile: EditorProfileSave): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/editorProfile", editorProfile).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createEditorProfile(editorProfile: EditorProfileSave): Promise<string> {
    return new Promise((resolve, reject) => {
        api.post("/editorProfile", editorProfile).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
